import { useState } from "react";

export default function PromotionsPage({ promotions, setPromotions, t }) {
    const [showForm, setShowForm] = useState(false);
    const [newPromo, setNewPromo] = useState({ name: "", sku: "", discount: "", startDate: "", endDate: "", priority: 3 });

    const inputStyle = { background: t.inputBg, border: `1px solid ${t.border}`, color: t.text, borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" };

    const handleAdd = () => {
        if (!newPromo.name || !newPromo.sku) return;
        setPromotions([...promotions, { id: Date.now(), ...newPromo }]);
        setShowForm(false);
        setNewPromo({ name: "", sku: "", discount: "", startDate: "", endDate: "", priority: 3 });
    };

    return (
        <div style={{ padding: 32 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
                <h2 style={{ fontSize: 22, fontWeight: 700, color: t.text, margin: 0 }}>🎯 Promotion 管理</h2>
                <button onClick={() => setShowForm(!showForm)} style={{ padding: "9px 18px", background: t.accent, border: "none", color: "white", borderRadius: 8, cursor: "pointer", fontSize: 14, fontWeight: 500 }}>＋ 新增 Promotion</button>
            </div>

            <div style={{ background: "#1e1b4b", border: "1px solid #3730a3", color: "#a5b4fc", borderRadius: 8, padding: "10px 16px", fontSize: 13, marginBottom: 20 }}>
                ⚠️ 本系統只推送基於商品數據的精準 Promotion，不推送普通廣告資料
            </div>

            {showForm && (
                <div style={{ background: t.surface, borderRadius: 12, padding: 24, border: `1px solid ${t.border}`, marginBottom: 24 }}>
                    <h3 style={{ color: t.text, marginBottom: 16 }}>新增 Promotion</h3>
                    {[
                        { label: "Promotion 名稱", key: "name", placeholder: "e.g. 夏日飲品9折" },
                        { label: "目標 SKU", key: "sku", placeholder: "e.g. JCE-033" },
                        { label: "折扣方式", key: "discount", placeholder: "e.g. 10% / Buy 2 Get 1" },
                        { label: "開始日期", key: "startDate", type: "date" },
                        { label: "結束日期", key: "endDate", type: "date" },
                    ].map((f) => (
                        <div key={f.key} style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 12 }}>
                            <label style={{ color: t.textMuted, fontSize: 13, fontWeight: 500 }}>{f.label}</label>
                            <input type={f.type || "text"} value={newPromo[f.key]}
                                onChange={(e) => setNewPromo({ ...newPromo, [f.key]: e.target.value })}
                                placeholder={f.placeholder} style={inputStyle} />
                        </div>
                    ))}
                    <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 16 }}>
                        <label style={{ color: t.textMuted, fontSize: 13, fontWeight: 500 }}>優先級</label>
                        <select value={newPromo.priority} onChange={(e) => setNewPromo({ ...newPromo, priority: Number(e.target.value) })} style={inputStyle}>
                            {[1, 2, 3, 4, 5].map((n) => <option key={n} value={n}>P{n} {n === 1 ? "(最高)" : n === 5 ? "(最低)" : ""}</option>)}
                        </select>
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                        <button onClick={handleAdd} style={{ padding: "9px 18px", background: t.accent, border: "none", color: "white", borderRadius: 8, cursor: "pointer", fontSize: 14 }}>確認新增</button>
                        <button onClick={() => setShowForm(false)} style={{ padding: "9px 18px", background: "transparent", border: `1px solid ${t.border}`, color: t.textMuted, borderRadius: 8, cursor: "pointer", fontSize: 14 }}>取消</button>
                    </div>
                </div>
            )}

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 16 }}>
                {promotions.map((p) => (
                    <div key={p.id} style={{ background: t.surface, borderRadius: 12, padding: 20, border: `1px solid ${t.border}` }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <span style={{ background: t.accentBg, color: t.accentText, fontSize: 11, fontWeight: 700, padding: "3px 8px", borderRadius: 20 }}>P{p.priority}</span>
                                <h4 style={{ color: t.text, fontSize: 14, fontWeight: 700, margin: 0 }}>{p.name}</h4>
                            </div>
                            <button onClick={() => setPromotions(promotions.filter((x) => x.id !== p.id))}
                                style={{ background: "transparent", border: "none", color: t.danger, cursor: "pointer", fontSize: 16, padding: "0 4px" }}>✕</button>
                        </div>
                        {[
                            { label: "目標 SKU", value: p.sku },
                            { label: "折扣", value: p.discount },
                            { label: "開始日期", value: p.startDate },
                            { label: "結束日期", value: p.endDate },
                        ].map((row) => (
                            <div key={row.label} style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                                <span style={{ color: t.textFaint, fontSize: 12 }}>{row.label}</span>
                                <span style={{ color: t.text, fontSize: 12, fontWeight: 600 }}>{row.value}</span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}